import getContentTagData from '../utils/ui/get-content-tag-data'

export default {
  methods: {
    getContentTagData (keys) {
      return getContentTagData(keys)
    }
  }
}
